module.exports = __webpack_public_path__ + "static/media/Aguat-Sad-Look.4ae91e3e.png";